__turbopack_context__.v({
  "className": "dm_sans_25221dd6-module__hv_KaW__className",
});
